export default "__VITE_ASSET__3d965cff__"